import React from "react";
import { useTheme } from "../context/ThemeContext";
import { useTranslation } from "../hooks/useTranslation";

export default function ThemeSwitcher({ compact = false }: { compact?: boolean }) {
  const { resolvedTheme, setPreference } = useTheme();
  const { t } = useTranslation();
  const dark = resolvedTheme === "dark";
  const nextLabel = dark ? t("theme.switchToLight") : t("theme.switchToDark");

  return (
    <button
      className={`theme-switcher${compact ? " theme-switcher--compact" : ""}`}
      type="button"
      aria-label={nextLabel}
      title={nextLabel}
      aria-pressed={dark}
      onClick={() => setPreference(dark ? "light" : "dark")}
    >
      {dark ? (
        <svg aria-hidden="true" viewBox="0 0 24 24"><path d="M21 12.8A8.5 8.5 0 1 1 11.2 3 6.7 6.7 0 0 0 21 12.8Z" /></svg>
      ) : (
        <svg aria-hidden="true" viewBox="0 0 24 24"><circle cx="12" cy="12" r="4" /><path d="M12 2v2M12 20v2M4.93 4.93l1.42 1.42M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.42-1.42M17.66 6.34l1.41-1.41" /></svg>
      )}
    </button>
  );
}
